import merge from 'lodash/merge'
import { omit } from 'lodash'
import { SET_ACTIVE_ENHANCEMENTS } from '../actions/setActiveEnhancementActions'
import { REMOVE_ACTIVE_ENHANCEMENT } from '../actions/removeActiveEnhancementActions'

const initialState = {
}

export default function activeEnhancementReducer(state = initialState, action) {
	switch(action.type) {

		case SET_ACTIVE_ENHANCEMENTS:
			// Select activeRoom manually
			return merge({}, state, action.payload)

		case REMOVE_ACTIVE_ENHANCEMENT:
			// Remove activeEnhancement by ID
			return omit(state, action.payload)

		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/activeEnhancementReducers.js